import { Button, Descriptions, Icons, Select } from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'
import { SetStateAction, useState } from 'react'

type EditableSelectFieldProps = {
  record: any,
  handleSave: any
  field: string
  options: { label: string, value: string }[]
}

export const EditableSelectField = ({ record, handleSave, field, options }: EditableSelectFieldProps) => {
  const t = useTranslate()

  const [editfield, setEditField] = useState(false)
  const [currentValue, setCurrentValue] = useState<string>(record?.[`${field}`])

  const handleEditValue = (isClose: boolean = false) => {
    if (isClose) {
      setCurrentValue(record?.[`${field}`])
      setEditField(false)
    } else {
      setEditField(!editfield)
    }
  }

  return (!editfield)
    ? <Descriptions.Item key={(record.id || record.order_id) + currentValue} label={t(`order.fields.${field}`)}>
        <div style={{ display: 'flex', alignItems: 'initial' }}>
          {t(`iva_status.select.${currentValue}`)}
          <Button shape='circle' style={{ border: 'none', top: -5, marginLeft: 20 }} icon={<Icons.EditOutlined />} onClick={() => handleEditValue()} />
        </div>
      </Descriptions.Item>
    : <Descriptions.Item label={t(`order.fields.${field}`)}>
        <div style={{ display: 'flex', alignItems: 'initial' }}>
          {/* <Input style={{ minWidth: '50px', maxWidth: '100px', height: '32px', marginLeft: 10, marginTop: -5 }} defaultValue={currentValue} onChange={(e) => onChangeValue(e.target.value)}/> */}
          <Select
            value={t(`iva_status.select.${currentValue}`)}
            onSelect={(value: SetStateAction<string>) => setCurrentValue(value)}
            options={options}
            style={{ minWidth: 150 }}
          />
          <Button shape='circle' style={{ border: 'none', top: -5, marginLeft: 10 }} icon={<Icons.SaveOutlined />} onClick={() => handleSave(currentValue, record, handleEditValue)} />
          <Button shape='circle' style={{ border: 'none', top: -5, marginLeft: 0 }} icon={<Icons.CloseOutlined />} onClick={() => handleEditValue(true)} />
        </div>
      </Descriptions.Item>
}
